import { Button, Col, Input, message, Form,Popover, Row, Space, Switch, Table, Upload, Modal } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { UploadOutlined } from "@ant-design/icons";
import {baseUrl} from "../../../../src/config"
export const Reviews=()=>{
const [reviews,setReviews]=useState([])
 const [fileList, setFileList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
     
const { Column, ColumnGroup } = Table;

interface DataType {
  key: React.Key;
  firstName: string;
  lastName: string;
  age: number;
  address: string;
  tags: string[];
}
const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
const navigate=useNavigate()
 const [reviewReq, setReviewReq] = useState({
    name: "",
    companyName: "",
    review: "",
    profile: "",
  });
   const [form] = Form.useForm();
    useEffect(() => {
        const storedData = localStorage.getItem("loginData");
        if (storedData) {
            // Parse the data into an object
            const loginData = JSON.parse(storedData);
          
            // Access the id from the stored data
            const userId = loginData.id;
          
            console.log("User ID:", userId);
          } else {
            console.log("No login data found");
          }
        getReviews();
      }, []);
    
      const getReviews = async () => {
        try {
          const resp = await axios.get(
            `${baseUrl}account/${loginData.id}/reviews?query=all`,
            {
              headers:{
                  Authorization:`Bearer ${loginData.authToken}`
              }
          }
          );
          console.log(resp.data); // Log the response to check
        
          setReviews(resp?.data);
        } catch (e) {
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          console.error(e);
        }
      }
 const handlePreview = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      document.body.append(image);
    };
    reader.readAsDataURL(file.originFileObj); // Read the file as data URL
  };
   const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setFileList([])
    form.resetFields();
    setIsModalVisible(false);
  };
      const updateReview = async (record,val) => {
        try {
          const resp = await axios.put(
            `${baseUrl}account/${loginData.id}/review/update`,{
              id:record?.id,
              isVisible:val
            },{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            
            message.success("Review updated successfully")
            getReviews()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          message.error("Failed to update review")
        }
      }


       
      
        const handlePostReview = async (values) => {
          // Handle posting the review (e.g., send to an API)
          try {
            const resp = await axios.post(`${baseUrl}review/create`, { ...reviewReq }); // Assuming your API endpoint is 'reviews'
            message.success("Review posted successfully!");
            form.resetFields();
            getReviews();
            setFileList([])
          } catch (e) {
            console.error(e);
          }
          setIsModalVisible(false);
        };
      
        const handleFileChange = ({ fileList }) => {
          console.log("File uploaded: ", fileList);
          setFileList(fileList);
          if (fileList && fileList.length > 0) {
            const file = fileList[0].originFileObj;
            const reader = new FileReader();
            reader.onloadend = () => {
              setReviewReq({
                ...reviewReq,
                profile: reader.result as string, // Set the profile picture as Base64 string
              });
            };
            reader.readAsDataURL(file); // Convert the image to Base64
          }
        };
      
    return(
      <div style={{width:"100%"}}>
      <div style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
        <div style={{textAlign:"left",fontSize:28,fontWeight:600}}>Reviews</div>
       <Button
                onClick={showModal}
                style={{
                  height: 30,
                  color: "#e4fbf6",
                  fontSize: 18,
                  background: "#1a6694",
                  border: "none",
                  marginTop: 60,
                  fontWeight: 500,
                }}
              >
                Add Review
              </Button>
      </div>
      <Table<DataType> dataSource={reviews}  pagination={{ pageSize: 20 }}>
<Column title="Name" dataIndex="name" key="name" />
<Column title="Company Name" dataIndex="companyName" key="companyName" />
<Column
title="Review"
dataIndex="review"
key="review"
render={(review: string) => (
 <>
<Popover content={<div>{review}</div>} trigger="click" ><div style={{color:"green",cursor:"pointer"}}>View review</div></Popover>
 </>
)}
/>
<Column
title="Profile"
dataIndex="profile"
key="profile"
render={(profile: string) => (
 <>
<Popover content={<div>{profile ?<img src={profile} style={{width:"200",height:"200px"}}></img>:"No Data"}</div>} trigger="click" ><div style={{color:"#b60063",cursor:"pointer"}}>View profile</div></Popover>
 </>
)}
/>
<Column
title="Action"
key="action"
render={(_: any, record: any) => (
 <Space size="middle">
   <a ><Switch value={record?.isVisible} onChange={(val)=>updateReview(record,val)}></Switch></a>
 </Space>
)}
/>
</Table>
  <Modal
        title={<span style={{ fontSize: "24px", fontWeight: "bold" }}>Post a Review</span>}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
        maskClosable={false}
        style={{ border: "2px solid #1a6694", height: 460, borderRadius: 8 }}
        bodyStyle={{ fontSize: "16px" }}
      >
        <Form form={form} onFinish={handlePostReview} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Name</span>}
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input placeholder="Enter your name" value={reviewReq?.name} onChange={(e) => setReviewReq({ ...reviewReq, name: e.target.value })} />
              </Form.Item>
            </Col>

            {/* Company Name and Input Field */}
            <Col span={12}>
              <Form.Item
                name="company"
                label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Company Name</span>}
                rules={[{ required: true, message: "Please input your company name!" }]}
              >
                <Input placeholder="Enter your company name" onChange={(e) => setReviewReq({ ...reviewReq, companyName: e.target.value })} />
              </Form.Item>
            </Col>
          </Row>

          {/* Review Field */}
          <Form.Item
            name="review"
            label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Review</span>}
            rules={[{ required: true, message: "Please write a review!" }]}
          >
            <Input.TextArea
              placeholder="Write your review here"
              rows={4}
              onChange={(e) => setReviewReq({ ...reviewReq, review: e.target.value })}
            />
          </Form.Item>

          {/* Profile Picture Upload */}
          <Form.Item
            name="profile"
            // value={reviewReq?.profile}
            label={<span style={{ fontWeight: "bold", fontSize: "18px" }}>Profile Picture</span>}
            valuePropName="fileList"
            getValueFromEvent={(e) => e && e.fileList}
          >
            <Upload
              accept="image/*"
              showUploadList={false}
              beforeUpload={() => false} // Disable automatic upload
              onChange={handleFileChange}
              onPreview={handlePreview}
              maxCount={1} // Limit to 1 file
            >
              <Button icon={<UploadOutlined />}>Upload Profile Picture</Button>
            </Upload>

            {fileList.length > 0 && (
              //   <div style={{ marginTop: 16, display: "flex", alignItems: "center" }}>
              <img
                src={URL.createObjectURL(fileList[0].originFileObj)} // Create URL for the uploaded image
                alt="Profile Preview"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginLeft: "10px"
                }}
              />
              //   </div>
            )}
          </Form.Item>

          {/* Footer with Cancel and Post Review buttons */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, fontWeight: 600 }}>
            <Button onClick={handleCancel} style={{ borderRadius: 12 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ background: "#1a6694", color: "#e4fbf6", borderRadius: 12 }}
            >
              Post Review
            </Button>
          </div>
        </Form>
      </Modal>
 </div>
    )
}